import { Link } from 'gatsby'
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Header = () => {
	
	function handleToggleMenu() {
		document.querySelector('.menu').classList.toggle('open');
		document.querySelector('.btnClose').style.display = 'block';
		// document.querySelector('.overlay').style.display = 'block';
		document.querySelector('body').style.overflow = 'hidden';
		document.querySelector('.btn-showmenu').classList.toggle('open');
	}

	function handleClosebtn() {
		document.querySelector('.menu').classList.remove('open');
		document.querySelector('.btnClose').style.display = 'none';
		// document.querySelector('.overlay').style.display = 'none';
		document.querySelector('body').style.overflow = 'visible';
		document.querySelector('.btn-showmenu').classList.toggle('open');
	}

	function handleScrollDisable() {
		document.querySelector('body').style.overflow = 'visible';
	}

	return (
		<div className="header">
			<Container>
				<div className="header-wrap">
					<button className="btn-showmenu" onClick={handleToggleMenu} onKeyDown={handleToggleMenu}>
						<img src="/app-icon-menu.svg" alt="app icon menu" />
					</button>
					<button className="btnClose" onClick={handleClosebtn} onKeyDown={handleClosebtn}>
						<img src="/app-icon-close.svg" alt="app icon down" />
					</button>
					{/* <div className="overlay" onClick={handleClosebtn} onKeyDown={handleClosebtn}></div> */}
					<div className="logo">
						<Link to="/" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
							<img src="/logo.svg" alt="Logo" />
						</Link>
					</div>
					<div className="menu">
						<ul className="menu-link">
							{/* <li className="has-sub">
								<h6>
									Our Products
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-multiple-row-custom-1">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Appvity eProduct Portfolio
													<h6>Build collaboration apps to connect everyone for your enterprise productivity.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/products/etask" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-etask.svg" alt="app icon etask" />
														<img className="app-img-mobile-tablet" src="/app-icon-etask-mobile-tablet.svg" alt="app icon etask mobile tablet" />
														eTask
													</div>
													<h6>Manage your tasks from different data sources across organizations. </h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/products/ehelpdesk" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-ehelpdesk.svg" alt="app icon ehelpdesk" />
														<img className="app-img-mobile-tablet" src="/app-icon-ehelpdesk-mobile-tablet.svg" alt="app icon ehelpdesk mobile tablet" />
														eHelpdesk
													</div>
													<h6>Easy to track every issue from your customers and boost your business’ credibility.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-multiple-row-custom-2">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/add-ins" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Add-Ins
													<h6>Better working experience between eProducts and Microsoft apps.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/products/excel-sync" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-excel-sync-header.svg" alt="app icon excel sync" />
														<img className="app-img-mobile-tablet" src="/app-icon-excel-sync-header-mobile-tablet.svg" alt="app icon excel sync mobile tablet" />
														Excel Sync
													</div>
													<h6>Manage data sourced from SharePoint or Appvity eSource within a Microsoft Excel spreadsheet.</h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/products/outlook" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-outlook.svg" alt="app icon outlook" />
														<img className="app-img-mobile-tablet" src="/app-icon-outlook-mobile-tablet.svg" alt="app icon outlook mobile tablet" />
														Outlook
													</div>
													<h6>Manage data sourced from SharePoint or Appvity eSource within a Microsoft Excel spreadsheet.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6>
									Our Services
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-single-row-custom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/services" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Service Overview
													<h6>Focus on the simplest ways to solve existing business problems.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/services/software-development" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Software Development Service
													<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/services/solution" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Solution Service
													<h6>Customize our defined solutions to fit your enterprise demand.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6>
									Support
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-single-row-custom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/support" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Support Center
													<h6>It's a place to assist you in time for any queries.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<a href="/OnlineDoc">
													Online Docs
													<h6>Provide user guide, application notes, and technical related documents.</h6>
												</a>
											</div>
											<div className="app-sub-child">
												<Link to="/support/blogs" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Blogs
													<h6>We share our experience related to applications and Microsoft technologies.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li> */}
							<li className="has-sub">
								<h6>
									<span>Products<img className="app-icon-menudown" src="/app-icon-menudown.svg" /></span>
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row id="app-subnav-row-header-productportfolio" className="app-subnav-row-header">
										<Col xs={12} md={12} lg={12}>
											<h4 id="app-sub-nav-headertext-productportfolio" className="app-sub-nav-headertext">Product Portfolio</h4>
										</Col>
									</Row>
									<Row className="app-subnav-row-content-top">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/efiles" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-efiles.svg" alt="app icon eFiles" />
														<img className="app-img-mobile-tablet" src="/app-icon-efiles-mobile-tablet.svg" alt="app icon eFiles mobile tablet" />
														eFiles
													</div>
													<h6>Advanced functionalities to enhance the management of files and folders in Teams and SharePoint.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/excel-sync" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-excel-sync-header.svg" alt="app icon excel sync" />
														<img className="app-img-mobile-tablet" src="/app-icon-excel-sync-header-mobile-tablet.svg" alt="app icon excel sync mobile tablet" />
														eXsync
													</div>
													<h6>Read and update data from SharePoint, or Appvity products within Microsoft Excel.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/erequest" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-erequest.svg" alt="app icon eRequest" />
														<img className="app-img-mobile-tablet" src="/app-icon-erequest-mobile-tablet.svg" alt="app icon eRequest mobile tablet" />
														eRequest
													</div>
													<h6>Initiate approval requests effortlessly, regardless of location or context - whether it’s a document, a form, or any other business-related task.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-subnav-row-content-bottom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/etask" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-etask.svg" alt="app icon etask" />
														<img className="app-img-mobile-tablet" src="/app-icon-etask-mobile-tablet.svg" alt="app icon etask mobile tablet" />
														eTask
													</div>
													<h6>Manage your tasks from different data sources across organizations. </h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/ehelpdesk" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-ehelpdesk.svg" alt="app icon eHelpdesk" />
														<img className="app-img-mobile-tablet" src="/app-icon-ehelpdesk-mobile-tablet.svg" alt="app icon eHelpdesk mobile tablet" />
														eHelpdesk
													</div>
													<h6>Effortlessly track every client issue and enhance your business’s credibility.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									{/* <Row className="app-subnav-row-content-top">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/efiles" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-efiles.svg" alt="app icon eFiles" />
														<img className="app-img-mobile-tablet" src="/app-icon-efiles-mobile-tablet.svg" alt="app icon eFiles mobile tablet" />
														eFiles
													</div>
													<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/excel-sync" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-excel-sync-header.svg" alt="app icon excel sync" />
														<img className="app-img-mobile-tablet" src="/app-icon-excel-sync-header-mobile-tablet.svg" alt="app icon excel sync mobile tablet" />
														eXsync
													</div>
													<h6>Manage data sourced from SharePoint or Appvity eSource within a Microsoft Excel spreadsheet.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/eprofile" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-undefined.svg" alt="app icon eProfile" />
														<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eProfile mobile tablet" />
														eProfile
													</div>
													<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-subnav-row-content-middle">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/erequest" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-erequest.svg" alt="app icon eRequest" />
														<img className="app-img-mobile-tablet" src="/app-icon-erequest-mobile-tablet.svg" alt="app icon eRequest mobile tablet" />
														eRequest
													</div>
													<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/ehelpdesk" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-ehelpdesk.svg" alt="app icon eHelpdesk" />
														<img className="app-img-mobile-tablet" src="/app-icon-ehelpdesk-mobile-tablet.svg" alt="app icon eHelpdesk mobile tablet" />
														eHelpdesk
													</div>
													<h6>Easy to track every issue from your customers and boost your business’ credibility.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/etask" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-etask.svg" alt="app icon etask" />
														<img className="app-img-mobile-tablet" src="/app-icon-etask-mobile-tablet.svg" alt="app icon etask mobile tablet" />
														eTask
													</div>
													<h6>Manage your tasks from different data sources across organizations. </h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-subnav-row-content-bottom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/elook" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-elook.svg" alt="app icon eLook" />
														<img className="app-img-mobile-tablet" src="/app-icon-elook-mobile-tablet.svg" alt="app icon eLook mobile tablet" />
														eLook
													</div>
													<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
												</Link>
											</div>
										</Col>
									</Row> */}
									<Row className="app-subnav-row-morelink">
										<Col xs={12} md={12} lg={12}>
											<div className="app-morelink-wrap">
												<Link to="/products" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<h6><span>See All Products<img className="app-icon-menunext" src="/app-icon-menunext.svg" /><img className="app-icon-menunext-mobile-tablet" src="/app-icon-menunext-mobile-tablet.svg" /></span></h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6>
									<span>Solutions<img className="app-icon-menudown" src="/app-icon-menudown.svg" /></span>
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-subnav-solutions">
										<Col xs={12} md={12} lg={8} className='app-subnav-solutions-colleft'>
											<Row className="app-subnav-row-header-solutions-left">
												<h4 className="app-sub-nav-headertext-solutions-left">Small & Medium Business Solutions</h4>
											</Row>
											<Row className="app-subnav-row-content-solutions-left-top">
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/products/erequest" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-erequest.svg" alt="app icon eRequest" />
																<img className="app-img-mobile-tablet" src="/app-icon-erequest-mobile-tablet.svg" alt="app icon eRequest mobile tablet" />
																eRequest
															</div>
															<h6>Initiate approval requests effortlessly, regardless of location or context - whether it’s a document, a form, or any other business-related task.</h6>
														</Link>
													</div>
													
												</Col>
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/esign" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-esign.svg" alt="app icon eSign" />
																<img className="app-img-mobile-tablet" src="/app-icon-esign-mobile-tablet.svg" alt="app icon eSign mobile tablet" />
																eSign
															</div>
															<h6>Authorize document signatures within your team or with external clients using various types of digital certificates.</h6>
														</Link>
													</div>
												</Col>
											</Row>
											<Row className="app-subnav-row-content-solutions-left-bottom">
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/einvoice" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-einvoice.svg" alt="app icon eInvoice" />
																<img className="app-img-mobile-tablet" src="/app-icon-einvoice-mobile-tablet.svg" alt="app icon eInvoice mobile tablet" />
																eInvoice
															</div>
															<h6>Streamline invoice management while ensuring compliance with tax codes for seamless retrieval and efficient information handling.</h6>
														</Link>
													</div>
													{/* <div className="app-sub-child">
														<Link to="/solutions/eorder" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-undefined.svg" alt="app icon eOrder" />
																<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eOrder mobile tablet" />
																eOrder
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div> */}
												</Col>
												{/* <Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/econtract" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-undefined.svg" alt="app icon eContract" />
																<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eContract mobile tablet" />
																eContract
															</div>
															<h6>Help manage contract creation, execution and amendments for the purpose of maximizing performance and minimizing risk.</h6>
														</Link>
													</div>
												</Col> */}
											</Row>
											{/* <Row className="app-subnav-row-content-solutions-left-top">
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/ebudget" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-ebudget.svg" alt="app icon eBudget" />
																<img className="app-img-mobile-tablet" src="/app-icon-ebudget-mobile-tablet.svg" alt="app icon eBudget mobile tablet" />
																eBudget
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/econtract" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-undefined.svg" alt="app icon eContract" />
																<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eContract mobile tablet" />
																eContract
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
											</Row>
											<Row className="app-subnav-row-content-solutions-left-middle">
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/eorder" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-undefined.svg" alt="app icon eOrder" />
																<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eOrder mobile tablet" />
																eOrder
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/esign" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-esign.svg" alt="app icon eSign" />
																<img className="app-img-mobile-tablet" src="/app-icon-esign-mobile-tablet.svg" alt="app icon eSign mobile tablet" />
																eSign
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
											</Row>
											<Row className="app-subnav-row-content-solutions-left-bottom">
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/einvoice" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-undefined.svg" alt="app icon eInvoice" />
																<img className="app-img-mobile-tablet" src="/app-icon-undefined-mobile-tablet.svg" alt="app icon eInvoice mobile tablet" />
																eInvoice
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
												<Col xs={12} md={12} lg={6}>
													<div className="app-sub-child">
														<Link to="/solutions/epayment" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
															<div className="app-sub-child-title">
																<img src="/app-icon-epayment.svg" alt="app icon ePayment" />
																<img className="app-img-mobile-tablet" src="/app-icon-epayment-mobile-tablet.svg" alt="app icon ePayment mobile tablet" />
																ePayment
															</div>
															<h6>Open a request for approval anytime, anywhere, whether it's a document, a project, or any other business-related task.</h6>
														</Link>
													</div>
												</Col>
											</Row> */}
										</Col>
										<Col xs={12} md={12} lg={4} className='app-subnav-solutions-colright'>
											<Row className="app-subnav-row-header-solutions-right">
												<h4 className="app-sub-nav-headertext-solutions-right">Enterprise Solutions</h4>
											</Row>	
											<Row className="app-subnav-row-content-solutions-right">
												<Col xs={12} md={12} lg={12} className='app-subnav-row-content-solutions-right-col'>
													<div className="app-sub-solutions-wrap-1">
														<div className="app-sub-solutions-left-wrap">
															<Link to="/solutions/procurementtopayment" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																<img className="app-icon-desktop" src="/app-icon-procurementtopayment.png" alt="Procurement to Payment" />
																<img className="app-icon-mobile" src="/app-icon-procurementtopayment-mobile.png" alt="Procurement to Payment" />
																<div className="app-sub-solutions-label"><h5>Procurement to Payment</h5></div>
															</Link>
														</div>
														<div className="app-sub-solutions-right-wrap">
															<div className="app-sub-solutions-top">
																<Link to="/solutions/documentmanagersystem" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																	<img className="app-icon-desktop" src="/app-icon-documentmanagement.png" alt="Document Management System" />
																	<img className="app-icon-mobile" src="/app-icon-documentmanagement-mobile.png" alt="Document Management System" />
																	<div className="app-sub-solutions-label"><h5>Document Management System</h5></div>
																</Link>
															</div>
															<div className="app-sub-solutions-bottom">
																<Link to="/solutions/collaborationportal" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																	<img className="app-icon-desktop" src="/app-icon-corporateportal.png" alt="Corporate Portal" />
																	<img className="app-icon-mobile" src="/app-icon-corporateportal-mobile.png" alt="Corporate Portal" />
																	<div className="app-sub-solutions-label"><h5>Collaboration Portal</h5></div>
																</Link>
															</div>
														</div>
													</div>
													{/* <div className="app-sub-solutions-wrap">
														<div className="app-sub-solutions-top-wrap">
															<Link to="/solutions/procurementtopayment" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																<img src="/ProcurementtoPayment.png" alt="Procurement to Payment" />
																<div className="app-sub-solutions-label"><h5>Procurement to Payment</h5></div>
															</Link>
														</div>
														<div className="app-sub-solutions-bottom-wrap">
															<div className="app-sub-solutions-left">
																<Link to="/solutions/documentmanagersystem" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																	<img src="/DocumentManagement.png" alt="Document Management System" />
																	<div className="app-sub-solutions-label"><h5>Document Management System</h5></div>
																</Link>
															</div>
															<div className="app-sub-solutions-right">
																<Link to="/solutions/contractmanagement" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
																	<img src="/ContractManagement.png" alt="Contract Management" />
																	<div className="app-sub-solutions-label"><h5>Contract Management</h5></div>
																</Link>
															</div>
														</div>
													</div> */}
												</Col>
											</Row>
										</Col>
									</Row>
									<Row className="app-subnav-row-morelink">
										<Col xs={12} md={12} lg={12}>
											<div className="app-morelink-wrap">
												<Link to="/solutions" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<h6><span>See All Solutions<img className="app-icon-menunext" src="/app-icon-menunext.svg" /><img className="app-icon-menunext-mobile-tablet" src="/app-icon-menunext-mobile-tablet.svg" /></span></h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6 className='app-nav-services'>
									<Link className='app-nav-toplink' to="/services" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
										Services
									</Link>
									<img className="app-icon-dot-notsub " src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
							</li>
							<li className="has-sub">
								<h6>
									<span>Support<img className="app-icon-menudown" src="/app-icon-menudown.svg" /></span>
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row id="app-subnav-row-header-supportcenter" className="app-subnav-row-header">
										<Col xs={12} md={12} lg={12}>
											<h4 id="app-sub-nav-headertext-supportcenter" className="app-sub-nav-headertext">Support Center</h4>
										</Col>
									</Row>
									<Row className="app-subnav-row-content">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<a href="/OnlineDoc">
													Online Docs
													<h6>Provide user guide, application notes, and technical related documents.</h6>
												</a>
											</div>
										</Col>
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/support/blogs" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Blogs
													<h6>We share our experience related to applications and Microsoft technologies.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-subnav-row-morelink">
										<Col xs={12} md={12} lg={12}>
											<div className="app-morelink-wrap">
												<Link to="/support" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<h6><span>See Support Center<img className="app-icon-menunext" src="/app-icon-menunext.svg" /><img className="app-icon-menunext-mobile-tablet" src="/app-icon-menunext-mobile-tablet.svg" /></span></h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
						</ul>
						{/* <div className="app-login-signup">
							<Link to="/" className="app-login">Login</Link>
							<Link to="/" className="app-signup">
								<span className="app-signup-text">You don’t have an account yet.</span>
								<span>Signup</span>
							</Link>
						</div> */}
					</div>
					{/* <div className="app-online-store">
						<h6>
							<a href="https://300u26337848130.3dcartstores.com/" className="app-login">Go to Store 
								<img src="/app-icon-go-to-store.svg" alt="app icon go to store" />
							</a>
						</h6>
					</div> */}
				</div>
			</Container>
		</div>
	)
}
export default Header